import React from 'react';
import { Dialog, DialogContent, Box, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

interface ProfileImageModalProps {
  open: boolean;
  onClose: () => void;
  src?: string;
  alt?: string;
}

const ProfileImageModal: React.FC<ProfileImageModalProps> = ({ open, onClose, src, alt }) => {
  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="md" PaperProps={{ sx: { bgcolor: '#000', } }}>
      <DialogContent sx={{ p: 0, position: 'relative', bgcolor: '#000' }}>
        <IconButton onClick={onClose} sx={{ position: 'absolute', top: 8, right: 8, zIndex: 2, color: '#fff' }} aria-label="Close">
          <CloseIcon />
        </IconButton>
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', bgcolor: '#000', minHeight: { xs: 300, md: 500 } }}>
          {src ? (
            <Box component="img" src={src} alt={alt || 'Profile'}
              sx={{ maxWidth: '100%', maxHeight: '80vh', objectFit: 'contain' }} />
          ) : null}
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default ProfileImageModal;
